// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211018/js/" + chunkId + "." + {"44":"f7a97a2b","225":"e66cb9fd","481":"e89f33e3","486":"0e4fb00e","770":"5e2173b5"}[chunkId] + ".0.6420568677522143.chunk.js";
};